import React from "react";
import styled from "styled-components";
import theme from "styled-theming";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const backgroundColor = theme.variants("mode", "variant", {
  secondary: {
    light: (props) => props.theme.colors.secondary.main.color,
    dark: (props) => props.theme.colors.secondary.main.color,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.color,
    dark: (props) => props.theme.colors.primary.main.color,
  },
});

const color = theme.variants("mode", "variant", {
  secondary: {
    light: (props) => props.theme.colors.secondary.main.contrastColor,
    dark: (props) => props.theme.colors.secondary.main.contrastColor,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.contrastColor,
    dark: (props) => props.theme.colors.primary.main.contrastColor,
  },
});

const TimeContainer = styled.div`
  background-color: ${backgroundColor};
  color: ${color};
  text-align: center;
  height: 56px;
  line-height: 56px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin-bottom: ${(props) => props.theme.margin.large};
  > .count-down-time {
    color: ${color};
    font-weight: bold;
  }
`;

TimeContainer.defaultProps = {
  variant: "secondary",
};

class TimeCountDownBox extends React.Component {
  static propTypes = {
    /**
     * Count down remaining time in seconds
     */
    remainingTime: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    this.timer = null;

    this.state = {
      remainingTime: props.remainingTime,
    };

    this.countDown = this.countDown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ remainingTime: nextProps.remainingTime });
  }

  componentDidMount() {
    this.timer = setInterval(this.countDown, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  countDown() {
    const { remainingTime } = this.state;
    this.setState({
      remainingTime: remainingTime - 1,
    });
  }

  render() {
    const { text, variant, t } = this.props;
    return (
      <TimeContainer
        variant={variant}
        className="count-down-container"
        dangerouslySetInnerHTML={renderRemainingDiscountTime(
          this.state.remainingTime,
          t,
        )}
      ></TimeContainer>
    );
  }
}

export function renderRemainingDiscountTime(sec, t) {
  const days = Math.floor(sec / 86400);
  sec = sec % 86400;

  const hours = Math.floor(sec / 3600);
  sec = sec % 3600;

  const min = Math.floor(sec / 60);
  sec = sec % 60;

  let timeStr = t("%s d", { postProcess: "sprintf", sprintf: [days] }) + " ";
  timeStr += t("%s h", { postProcess: "sprintf", sprintf: [hours] }) + " ";
  timeStr += t("%s m", { postProcess: "sprintf", sprintf: [min] }) + " ";
  timeStr += t("%s s", { postProcess: "sprintf", sprintf: [sec] }) + " ";

  return {
    __html: t("Place your order within %s and get an extra reduced price!", {
      postProcess: "sprintf",
      sprintf: [`<span class="count-down-time">${timeStr}</span>`],
    }),
  };
}

export default withTranslation()(TimeCountDownBox);
